// extracted by mini-css-extract-plugin
export default {"Content":"Layout_Content__tCzpF","Alert":"Layout_Alert__zQhuw"};